import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { Tooltip } from "@mui/material";
import MaterialTable from "material-table";
import UiUtils from "../../../provider/UiUtils";
import VisibilityIcon from "@mui/icons-material/Visibility";
// import DeleteIconButton from "../buttons/DeleteIconButton";
import Utils from "../../../provider/Utils";
import FetchServerData from "../../../provider/FetchServerData";
import store from "../../../redux/store";
import Button from "@mui/material/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import PurchaseEventPlan from "../eventText/PurchaseEventPlan";
import PtsAlert from "../ptsAlert/PtsAlert";
import MenuWithBreadScrum from "../menu/MenuWithBreadScrum";
import BillingReceipt from "./BillingReceipt";

class EventBilling extends Component {
  header = store.getState().header.header;
  businessDomainId = store.getState().businessDomain?.businessDomainId;
  eventBusinessDomain = store.getState().businessDomain?.eventState;
  breadCrumb = [{ pageid: "", uiname: "Billing" }];
  constructor(props) {
    super(props);
    this.state = {
      initialPage: 0,
      pageSize: 20,
      eventPlanId: "",
      subscriptionId: "",
      subscriptions: [],
      customerPaymentList: [],
      overagePaymentList: [],
      planList: [],
      isUpgradePlan: false,
      receipt: false,
      isReceiptOpen: false,
      render: false,
    };
    this.getEventBillingDetails();
  }
  getEventBillingDetails() {
    const postObject = {
      header: this.header,
      event: {
        id: this.businessDomainId,
      },
    };
    FetchServerData.callPostService("/billingms/getForEvent", postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          let creditCardList = output.data.creditCardList;
          let customerPaymentList = output.data.customerPaymentList;
          let overagePaymentList = output.data.overagePaymentList;
          let subscriptions = output.data.subscriptions;
          let businessUseCase = output.data.businessUseCase;
          let isPaging = false;

          if (customerPaymentList.length > this.state.pageSize) {
            isPaging = true;
          }
          for (let i = 0; i < customerPaymentList.length; i++) {
            customerPaymentList[i].cycleStartDate = Utils.getUtcToEventLocalTime(
              customerPaymentList[i].cycleStartDate
            );
            customerPaymentList[i].cycleEndDate = Utils.getUtcToEventLocalTime(
              customerPaymentList[i].cycleEndDate
            );
            customerPaymentList[i].orderDate = Utils.getUtcToEventLocalTime(
              customerPaymentList[i].orderDate
            );
          }

          for (let i = 0; i < overagePaymentList.length; i++) {
            overagePaymentList[i].cycleStartDate = Utils.getUtcToEventLocalTime(
              overagePaymentList[i].cycleStartDate
            );
            overagePaymentList[i].cycleEndDate = Utils.getUtcToEventLocalTime(
              overagePaymentList[i].cycleEndDate
            );
            overagePaymentList[i].orderDate = Utils.getUtcToEventLocalTime(
              overagePaymentList[i].orderDate
            );
          }

          for (let i = 0; i < subscriptions.length; i++) {
            subscriptions[i].subscriptionStartdate = Utils.getUtcToEventLocalTime(
              subscriptions[i].subscriptionStartdate
            );
            subscriptions[i].subscriptionEnddate = Utils.getUtcToEventLocalTime(
              subscriptions[i].subscriptionEnddate
            );
            subscriptions[i].orderDate = Utils.getUtcToEventLocalTime(
              subscriptions[i].orderDate
            );
            subscriptions[i].nextBillingDate = Utils.getUtcToEventLocalTime(
              subscriptions[i].nextBillingDate
            );
          }
          this.setState({
            render: true,
            action: "view",
            isPaging: isPaging,
            creditCardList: creditCardList,
            customerPaymentList: customerPaymentList,
            overagePaymentList: overagePaymentList,
            subscriptions: subscriptions,
            businessUseCase: businessUseCase,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  customerOrderpurchasePlan(plan) {
    // this.setState({
    //   action: "PurchasePlan",
    //   planId: plan.id,
    // });

    if (this.state.isUpgradePlan) {
      this.setState({
        action: "PurchasePlan",
        pageId: "UpgradePlan",
        eventPlanId: plan?.id,
        eventId: this.businessDomainId,
      });
    } else
      this.setState({
        action: "PurchasePlan",
        pageId: "SubscriptionsPlan",
        eventPlanId: plan?.id,
        eventId: this.businessDomainId,
        subscriptionId: "",
      });
  }

  getPlanListForUseCase() {
    const postObject1 = {
      header: this.header,
      businessUseCase: {
        id: this.state.businessUseCase?.id,
      },
    };
    FetchServerData.callPostService(
      "/planms/getForBusinessUseCase",
      postObject1
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let planList = output.data.planList;
        this.setState({
          render: true,
          open: true,
          planList: planList,
          isUpgradePlan: false,
        });
      } else {
      }
    });
  }
  handleClose() {
    this.setState({
      open: false,
    });
  }
  handleReceiptClose() {
    this.setState({
      isReceiptOpen: false,
    });
  }
  upgradePlanListForUseCase(data) {
    const postObject1 = {
      header: this.header,
      businessUseCase: {
        id: this.state.businessUseCase?.id,
      },
    };
    FetchServerData.callPostService(
      "/planms/getForBusinessUseCase",
      postObject1
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let planList = output.data.planList;
        const upgradePlanList = planList.filter(
          (item) => item.price > data?.price
        );
        this.setState({
          render: true,
          open: true,
          planList: upgradePlanList,
          isUpgradePlan: true,
          subscriptionId: data.id,
        });
      } else {
      }
    });
  }
  deleteCoustomerOrder(data) {
    const postObject = {
      header: this.header,
      customerOrder: {
        id: data?.id,
      },
    };

    FetchServerData.callPostService("/customerOrderms/delete", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.getEventBillingDetails();
        } else {
        }
      }
    );
  }

  toReceiptDetails(e, data) {
    if (
      this.billingReceiptDialogueRef &&
      this.billingReceiptDialogueRef.current
    ) {
      this.billingReceiptDialogueRef.current.showReceiptDetails(data);
    }
  }

  render() {
    this.billingReceiptDialogueRef = React.createRef();
    if (this.state.action === "PurchasePlan") {
      return (
        <PurchaseEventPlan
          pageId={this.state.pageId}
          eventPlanId={this.state.eventPlanId}
          eventId={this.state.eventId}
          subscriptionId={this.state.subscriptionId}
        />
      );
    } else {
      return this.eventBilling();
    }
  }

  eventBilling() {
    if (this.state.render === false) {
      return <div />;
    } else {
      return (
        <>
          <MenuWithBreadScrum
            breadCrumb={this.breadCrumb}
            history={this.props.history}
            name="Billing"
          />
          <div className="row mt-3" style={{ padding: "0em 0em" }}>
            <div className="col-md-12">
              <div
                className="card "
                id="giveBeeCard"
                style={{ borderRadius: "0rem " }}
              >
                <div
                  className="card-header d-flex align-items-center justify-content-between"
                  id="assetCardHeader"
                >
                  <h6 className="mb-0" id="headerLabel">
                    <b>Event Plan</b>
                  </h6>
                </div>
                <div className="card-body">
                  <div className="row">
                    {this.state.subscriptions.map((value, index) => (
                      <>
                        <>
                          <div className="col-md-3">
                            <div
                              className="row d-flex"
                              style={{
                                height: "100%",
                              }}
                            >
                              <div className="col-md-12">
                                <div
                                  className="row d-flex"
                                  style={{
                                    height: "100%",
                                  }}
                                >
                                  <div className="col-md-12">
                                    <div
                                      className="box"
                                      data-aos="zoom-in"
                                      data-aos-delay={100}
                                      style={{
                                        padding: "0em",
                                        position: "relative",
                                        height: "100%",
                                      }}
                                      id="regPlanBox"
                                    >
                                      <div
                                        className="regplan-inner plan_card plan_card_bottom d-flex flex-column"
                                        style={{
                                          height: "100%",
                                        }}
                                      >
                                        <div
                                          className="entry-title plan_card"
                                          style={{
                                            background:
                                              value?.customerPlan
                                                ?.colorSecondary,
                                          }}
                                        >
                                          <h3
                                            className="plan_card"
                                            style={{
                                              padding: "7px",
                                              color: "#fff",
                                              background:
                                                value?.customerPlan
                                                  ?.colorPrimary,
                                            }}
                                          >
                                            {value?.customerPlan?.name}
                                          </h3>
                                          <div
                                            className="price"
                                            style={{
                                              background:
                                                value?.customerPlan
                                                  ?.colorPrimary,
                                            }}
                                          >
                                            <span
                                              style={{
                                                left: "20px",
                                              }}
                                            >
                                              {`$${Utils.formatWithCommas(
                                                value?.customerPlan?.price
                                              )}`}
                                            </span>
                                          </div>
                                        </div>
                                        <div className="entry-content flex-grow-1 d-flex flex-column pb-2">
                                          <ul className="flex-grow-1 ">
                                            {value?.customerPlan?.planItems.map(
                                              (item, i) => (
                                                <li
                                                  key={i}
                                                  style={{
                                                    padding: "0.2em",
                                                    fontWeight:
                                                      item?.isFontBold && "600",
                                                    fontStyle:
                                                      item?.isFontItalic &&
                                                      "italic",
                                                  }}
                                                >
                                                  {item.name}
                                                </li>
                                              )
                                            )}
                                          </ul>
                                          {/* {index === 0 &&
                                            (Utils.equalsIgnoreCase(
                                              value.subscriptionStatus,
                                              "Active"
                                            ) ||
                                              Utils.equalsIgnoreCase(
                                                value.subscriptionStatus,
                                                "Completed"
                                              )) && (
                                              <div className="row p-3">
                                                {!value?.customerPlan
                                                  ?.highestPlan && (
                                                    <div className="buy_now_btn2 col-md-12 text-center mt-auto">
                                                      <div className="btn_plan1">
                                                        <a
                                                          style={{
                                                            borderRadius: "10px",
                                                            backgroundColor:
                                                              value?.customerPlan
                                                                ?.colorPrimary,
                                                          }}
                                                          onClick={() =>
                                                            this.upgradePlanListForUseCase(
                                                              value?.customerPlan
                                                            )
                                                          }
                                                        >
                                                          Upgrade Plan
                                                        </a>
                                                      </div>
                                                    </div>
                                                  )}
                                              </div>
                                            )} */}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-md-5 align-self-center"
                            style={{ marginLeft: "40px" }}
                          >
                            <div className="row">
                              <label
                                className="col-sm-4 col-form-label fw-bold"
                                htmlFor="basic-default-name"
                                id="assetFormLabel"
                              >
                                Event Payment Date
                              </label>
                              <div className="col-sm-8" id="givbeeText">
                                <span>{value.orderDate}</span>
                              </div>
                            </div>
                            <div className="row">
                              <label
                                className="col-sm-4 col-form-label fw-bold"
                                htmlFor="basic-default-name"
                                id="assetFormLabel"
                              >
                                Start date
                              </label>
                              <div className="col-sm-8" id="givbeeText">
                                <span>
                                  {Utils.ptsDateFormat(
                                    this.eventBusinessDomain?.startDate
                                  )}
                                </span>
                              </div>
                            </div>
                            <div className="row">
                              <label
                                className="col-sm-4 col-form-label fw-bold"
                                htmlFor="basic-default-name"
                                id="assetFormLabel"
                              >
                                End date
                              </label>
                              <div className="col-sm-8" id="givbeeText">
                                <span>
                                  {Utils.ptsDateFormat(
                                    this.eventBusinessDomain?.endDate
                                  )}
                                </span>
                              </div>
                            </div>
                            {/* <div className="row">
                              <label
                                className="col-sm-5 col-form-label fw-bold"
                                htmlFor="basic-default-name"
                                id="assetFormLabel"
                              >
                                Status
                              </label>
                              <div className="col-sm-7" id="givbeeText">
                                <span>{value.subscriptionStatus}</span>
                              </div>
                            </div> */}
                            {value.subscriptionType !== "Onetime" && (
                              <div className="row">
                                <label
                                  className="col-sm-3 col-form-label fw-bold"
                                  htmlFor="basic-default-name"
                                  id="assetFormLabel"
                                >
                                  Next Billing Date
                                </label>
                                <div className="col-sm-9" id="OrganizationCol">
                                  <span>
                                    {value.nextBillingDate !== null
                                      ? value.nextBillingDate
                                      : ""}
                                  </span>
                                </div>
                              </div>
                            )}
                          </div>
                          {/* <div className="row mt-4">
                            {index === 0 && (
                              <>
                                {!Utils.equalsIgnoreCase(
                                  value.subscriptionStatus,
                                  "Completed"
                                ) ? (
                                  <div className="col-md-4">
                                    <Button
                                      style={{
                                        background: "rgb(242, 109, 33)",
                                        color: "rgb(255, 255, 255)",
                                        borderBottom:
                                          "3px solid rgb(99, 98, 98)",
                                        borderRadius: "5px",
                                        // width: "120px",
                                        padding: "5px 10px",
                                        textTransform: "capitalize",
                                      }}
                                      onClick={this.getPlanListForUseCase.bind(
                                        this
                                      )}
                                    >
                                      Purchase Plan
                                    </Button>
                                  </div>
                                ) : (
                                  <div
                                    className="col-md-3 text-center"
                                    style={{ width: "305px" }}
                                  >
                                    <Button
                                      style={{
                                        background: "rgb(242, 109, 33)",
                                        color: "rgb(255, 255, 255)",
                                        borderBottom:
                                          "3px solid rgb(99, 98, 98)",
                                        borderRadius: "5px",
                                        // width: "120px",
                                        padding: "5px 10px",
                                        textTransform: "capitalize",
                                      }}
                                      onClick={this.upgradePlanListForUseCase.bind(
                                        this,
                                        value
                                      )}
                                    >
                                      Upgrade Plan
                                    </Button>
                                  </div>
                                )}
                              </>
                            )}
                            {index === 0 &&
                              Utils.equalsIgnoreCase(
                                value.subscriptionStatus,
                                "Completed"
                              ) && (
                                <div className="row p-3">
                                  <div className="buy_now_btn2 col-md-12 text-center mt-auto">
                                    <div className="btn_plan1">
                                      <a
                                        style={{
                                          borderRadius: "10px",
                                          backgroundColor:
                                            value?.customerPlan?.colorPrimary,
                                        }}
                                        onClick={() =>
                                          this.upgradePlanListForUseCase(
                                            value?.customerPlan
                                          )
                                        }
                                      >
                                        Upgrade Plan
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              )}
                          </div> */}
                        </>
                      </>
                    ))}
                    {this.state.subscriptions.length === 0 && (
                      <div className="col-md-4 align-content-center">
                        <Button
                          style={{
                            background: "rgb(242, 109, 33)",
                            color: "rgb(255, 255, 255)",
                            borderBottom: "3px solid rgb(99, 98, 98)",
                            borderRadius: "5px",
                            // width: "120px",
                            padding: "5px 10px",
                            textTransform: "capitalize",
                          }}
                          onClick={this.getPlanListForUseCase.bind(this)}
                        >
                          Purchase Plan
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {this.state.customerPaymentList.length > 0 && (
            <div className="materialTable mt-3" style={{ width: "100%" }}>
              <>
                <MaterialTable
                  title="Plan Charges"
                  onRowClick={(event, rowData) => {
                    this.toReceiptDetails(event, rowData);
                    event.stopPropagation();
                  }}
                  icons={UiUtils.getMaterialTableIcons()}
                  localization={{
                    body: {
                      emptyDataSourceMessage: (
                        <h5 className="dataNotAvailable">No data found.</h5>
                      ),
                    },
                  }}
                  columns={[
                    {
                      title: "#",
                      render: (rowData) => rowData.tableData.id + 1,
                      width: "5%",
                      align: "left",
                      cellStyle: {
                        width: "6%",
                      },
                    },
                    {
                      title: "Type",
                      field: "subscriptionType",
                      cellStyle: {
                        width: "15%",
                      },
                    },
                    {
                      title: "Amount $",
                      // field: "totalAmount",
                      render: (rowData) =>
                        `${rowData.currencySymbol !== null
                          ? rowData.currencySymbol
                          : ""
                        }${Utils.formatWithCommas(rowData.paidAmount)}`,
                      cellStyle: {
                        width: "15%",
                      },
                    },
                    {
                      title: "Text Usage",
                      render: (rowData) => {
                        const used =
                          Utils.formatWithCommas(rowData.consumedCredits) ?? 0;
                        const avail =
                          Utils.formatWithCommas(rowData.availableCredits) ?? 0;
                        return (
                          <div
                            style={{
                              display: "flex",
                              width: "100%",
                            }}
                          >
                            <span>{`${used} / ${avail}`}</span>
                          </div>
                        );
                      },
                      cellStyle: { width: "15%" },
                    },
                    {
                      title: "Overages $",
                      render: (rowData) =>
                        rowData.overageCharges > 0 ? (
                          rowData.overageDescription ? (
                            <Tooltip
                              title={rowData.overageDescription}
                              arrow
                              classes={{
                                popper: "custom-tooltip",
                              }}
                            >
                              <span>
                                {rowData.currencySymbol ?? ""}
                                {Utils.formatWithCommas(rowData.overageCharges)}
                              </span>
                            </Tooltip>
                          ) : (
                            <span>
                              {rowData.currencySymbol ?? ""}
                              {Utils.formatWithCommas(rowData.overageCharges)}
                            </span>
                          )
                        ) : (
                          "NA"
                        ),
                      customSort: (a, b) =>
                        parseFloat(a.overageCharges) -
                        parseFloat(b.overageCharges),
                      cellStyle: { width: "15%" },
                    },
                    {
                      title: "Start Date",
                      field: "cycleStartDate",
                      cellStyle: {
                        width: "12%",
                      },
                    },
                    {
                      title: "End Date",
                      field: "cycleEndDate",
                      cellStyle: {
                        width: "12%",
                      },
                    },
                    {
                      title: "Transaction ID",
                      field: "transactionId",
                      cellStyle: {
                        width: "18%",
                      },
                      headerStyle: {
                        width: "18%",
                        whiteSpace: "nowrap",
                      },
                    },
                    {
                      title: "Payment",
                      field: "paymentStatus",
                      cellStyle: {
                        width: "15%",
                      },
                    },
                  ]}
                  data={this.state.customerPaymentList}
                  options={{
                    emptyRowsWhenPaging: false,
                    sorting: true,
                    search: true,
                    actionsColumnIndex: -1,
                    initialPage: this.state.initialPage,
                    pageSize: this.state.pageSize,
                    pageSizeOptions: Utils.materialTablePageSize(),
                    paging: this.state.isPaging,
                  }}
                // actions={[
                //   (rowData) =>
                //     rowData?.status !== "Completed" &&
                //     rowData?.status !== "Active" && {
                //       icon: () => (
                //         <DeleteIconButton
                //           domainObject={rowData.name}
                //           onClick={this.deleteCoustomerOrder.bind(
                //             this,
                //             rowData
                //           )}
                //         />
                //       ),
                //     },
                // ]}
                />
              </>
            </div>
          )}
          {this.state.overagePaymentList.length > 0 && (
            <div className="materialTable mt-3" style={{ width: "100%" }}>
              <>
                <MaterialTable
                  title="Overages Charges"
                  icons={UiUtils.getMaterialTableIcons()}
                  localization={{
                    body: {
                      emptyDataSourceMessage: (
                        <h5 className="dataNotAvailable">No data found.</h5>
                      ),
                    },
                  }}
                  columns={[
                    {
                      title: "#",
                      render: (rowData) => rowData.tableData.id + 1,
                      width: "5%",
                      align: "left",
                      cellStyle: {
                        width: "6%",
                      },
                    },
                    {
                      title: "Plan",
                      field: "subscriptionType",
                      cellStyle: {
                        width: "15%",
                      },
                    },
                    {
                      title: "Amount",
                      // field: "totalAmount",
                      render: (rowData) =>
                        `${rowData.currencySymbol !== null
                          ? rowData.currencySymbol
                          : ""
                        }${Utils.formatWithCommas(rowData.paidAmount)}`,
                      cellStyle: {
                        width: "15%",
                      },
                    },
                    {
                      title: "Payment Date",
                      field: "orderDate",
                      cellStyle: {
                        width: "15%",
                      },
                    },
                    {
                      title: "Start Date",
                      field: "cycleStartDate",
                      cellStyle: {
                        width: "15%",
                      },
                    },
                    {
                      title: "End Date",
                      field: "cycleEndDate",
                      cellStyle: {
                        width: "15%",
                      },
                    },
                    {
                      title: "Payment",
                      field: "paymentStatus",
                      cellStyle: {
                        width: "15%",
                      },
                    },
                    {
                      title: "View",
                      render: (rowData) => {
                        return (
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={this.toReceiptDetails.bind(this, rowData)}
                          >
                            <VisibilityIcon />
                          </IconButton>
                        );
                      },
                      headerStyle: {
                        textAlign: "center",
                      },
                      cellStyle: {
                        width: "8%",
                        textAlign: "center",
                      },
                    },
                  ]}
                  data={this.state.overagePaymentList}
                  options={{
                    emptyRowsWhenPaging: false,
                    sorting: true,
                    search: true,
                    actionsColumnIndex: -1,
                    initialPage: this.state.initialPage,
                    pageSize: this.state.pageSize,
                    pageSizeOptions: Utils.materialTablePageSize(),
                    paging: this.state.isPaging,
                  }}
                // actions={[
                //   (rowData) =>
                //     rowData?.status !== "Completed" &&
                //     rowData?.status !== "Active" && {
                //       icon: () => (
                //         <DeleteIconButton
                //           domainObject={rowData.name}
                //           onClick={this.deleteCoustomerOrder.bind(
                //             this,
                //             rowData
                //           )}
                //         />
                //       ),
                //     },
                // ]}
                />
              </>
            </div>
          )}
          <BillingReceipt
            ref={this.billingReceiptDialogueRef}
            style={{ float: "right" }}
          />
          <Dialog
            open={this.state.open}
            onClose={this.handleClose.bind(this)}
            maxWidth="xl"
            className="planPurchaseDialogue"
          >
            <DialogTitle id="scroll-dialog-title">
              <span style={{ color: "#fff", fontWeight: "600" }}>Plans</span>
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={this.handleClose.bind(this)}
              style={{
                position: "absolute",
                right: 8,
                top: 4,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
            </IconButton>
            <DialogContent>
              <div
                md={12}
                style={{
                  width: "100%",
                  color: "#000",
                  fontSize: "small",
                  padding: "0.5em",
                }}
              >
                <div className="row mt-2">
                  <div className="col-md-12">
                    <div className="row d-flex align-item-stretch">
                      {this.state.planList.map((plan, index) => (
                        <div className="col-md-3 mt-4">
                          <div
                            className="row d-flex"
                            style={{
                              height: "100%",
                            }}
                          >
                            <div className="col-md-12">
                              <div
                                className="box"
                                data-aos="zoom-in"
                                data-aos-delay={100}
                                style={{
                                  padding: "0em",
                                  position: "relative",
                                  height: "100%",
                                }}
                                id="regPlanBox"
                              >
                                <div
                                  className="regplan-inner plan_card plan_card_bottom d-flex flex-column"
                                  style={{
                                    height: "100%",
                                  }}
                                >
                                  <div
                                    class="entry-title plan_card"
                                    style={{
                                      background: plan.colorSecondary,
                                    }}
                                  >
                                    <h3
                                      class="plan_card"
                                      style={{
                                        padding: "7px",
                                        color: "#fff",
                                        background: plan.colorPrimary,
                                      }}
                                    >
                                      {plan.name}
                                    </h3>
                                    <div
                                      class="price"
                                      style={{
                                        background: plan.colorPrimary,
                                      }}
                                    >
                                      <span
                                        style={{
                                          left: "20px",
                                        }}
                                      >
                                        {`$${Utils.formatWithCommas(
                                          plan.price
                                        )}`}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="entry-content flex-grow-1 d-flex flex-column">
                                    <ul className="flex-grow-1">
                                      {plan?.planItems.map(
                                        (planItem, index) => (
                                          <li
                                            style={{
                                              padding: "0.2em",
                                              fontWeight:
                                                planItem?.isFontBold && "600",
                                              fontStyle:
                                                planItem?.isFontItalic &&
                                                "italic",
                                              fontSize:
                                                planItem?.isFontSmall && "12px",
                                            }}
                                          >
                                            {planItem.name}
                                          </li>
                                        )
                                      )}
                                    </ul>
                                    <div className="row p-3">
                                      <div className="buy_now_btn2 col-md-12 text-center mt-auto">
                                        <div className="btn_plan1">
                                          <a
                                            style={{
                                              borderRadius: "10px",
                                              backgroundColor:
                                                plan.colorPrimary,
                                            }}
                                            onClick={this.customerOrderpurchasePlan.bind(
                                              this,
                                              plan
                                            )}
                                          >
                                            Select
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </DialogContent>
          </Dialog>
          {/* <Dialog
          open={this.state.isReceiptOpen}
          onClose={this.handleReceiptClose.bind(this)}
          maxWidth="xl"
        >
          <DialogTitle id="scroll-dialog-title">
            <span style={{ color: "#fff", fontWeight: "600" }}>Receipt</span>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={this.handleReceiptClose.bind(this)}
            style={{
              position: "absolute",
              right: 8,
              top: 4,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
          </IconButton>
          <DialogContent>
            <div
              md={12}
              style={{
                width: "100%",
                color: "#000",
                fontSize: "small",
                padding: "0.5em",
              }}
            >
              <div
                className="text-start text-align-justify tollFreeNumberError"
                dangerouslySetInnerHTML={{
                  __html: this.state.receipt ? this.state.receipt : "",
                }}
              ></div>
            </div>
          </DialogContent>
        </Dialog> */}
        </>
      );
    }
  }
}
export default withRouter(EventBilling);
